<template>
  <p class="error-message">
    <!--стандартная ошибка-->
    <span v-if="type == 'standart'">
      {{$t('errors.standard')}}
    </span>
    <!---->

    <!--mail-->
    <span v-if="type == 'mail'">
      {{$t('errors.email')}}
    </span>
    <span v-if="type == 'mailFalse'">
      {{$t('errors.mailFalse')}}
    </span>
    <!---->

    <!--Короткий пароль-->
    <span v-if="type == 'passLength'">
      {{$t('errors.passLength')}} {{minLength}} {{$t('errors.passLength1')}}
    </span>
    <!---->

    <!--Несовпадение паролей-->
    <span v-if="type == 'passDouble'">
      {{$t('errors.passDouble')}}
    </span>
    <!---->

    <!--неверный пароль-->
    <span v-if="type == 'wrongPass'">
      {{$t('errors.wrongPass')}}
    </span>
    <!---->

    <!--Tel length-->
    <span v-if="type == 'telLength'">
      {{$t('errors.telLength')}} {{minLength}} {{$t('errors.telLength1')}}
    </span>
    <!---->

    <!--file size-->
    <span v-if="type == 'fileSize'">
      {{$t('errors.fileSize')}} {{minLength}} {{$t('errors.fileSizeMB')}}
    </span>
    <!---->
  </p>
</template>

<script>
  export default {
    name: 'errors',
    props: {
      type: {
        type: String,
        default: 'standart',
      },
      minLength: {
        type: String || Number,
        required: false
      }
    }
  }
</script>

<style scoped lang="scss">
  .error-message {
    font-family: $mr;
    font-size: 12px;
    color: $red;
    margin-top: 5px;
    text-align: left;
  }
</style>
